<div>
  <h1 style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Navy Cash® Card</h1>
  <p class="s1" style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">(Open
    Loop Account only)</p>
  <p class="s2"
     style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
    Refer to your Navy Cash or Navy Cash Visitor Card Cardholder Agreement for information regarding
    the Closed Loop Account of your Navy Cash Card or the Navy Cash Visitor Card.</p>
  <p style="text-indent: 0pt;text-align: left;"><br/></p>
  <p style="text-indent: 0pt;text-align: left;"><span></span></p>
  <p style="padding-top: 2pt;padding-left: 28pt;text-indent: 0pt;text-align: center;">You may
    receive your wages via direct deposit to your bank account or this Navy Cash Card. Tell the
    Disbursing Office or Defense Finance Accounting Service (“DFAS”) which option you choose.</p>
  <p style="text-indent: 0pt;text-align: left;"><br/></p>
  <table style="border-collapse:collapse;margin-left:65.644pt" cellspacing="0">
    <tr style="height:25pt">
      <td style="width:83pt"><p class="s3"
                                style="padding-left: 2pt;text-indent: 0pt;line-height: 14pt;text-align: left;">
        Monthly fee</p></td>
      <td style="width:100pt"><p class="s3"
                                 style="padding-left: 10pt;text-indent: 0pt;line-height: 14pt;text-align: left;">
        Per purchase</p></td>
      <td style="width:122pt"><p class="s3"
                                 style="padding-left: 14pt;text-indent: 0pt;line-height: 14pt;text-align: left;">
        ATM withdrawal</p></td>
      <td style="width:89pt"><p class="s3"
                                style="padding-left: 13pt;text-indent: 0pt;line-height: 14pt;text-align: left;">
        Cash deposit</p></td>
    </tr>
    <tr style="height:31pt">
      <td style="width:83pt"><p class="s4"
                                style="padding-top: 6pt;padding-left: 2pt;text-indent: 0pt;line-height: 23pt;text-align: left;">
        $0</p></td>
      <td style="width:100pt"><p class="s4"
                                 style="padding-top: 6pt;padding-left: 10pt;text-indent: 0pt;line-height: 23pt;text-align: left;">
        $0</p></td>
      <td style="width:122pt"><p class="s4"
                                 style="padding-top: 6pt;padding-left: 14pt;text-indent: 0pt;line-height: 23pt;text-align: left;">
        $0</p></td>
      <td style="width:89pt"><p class="s4"
                                style="padding-top: 6pt;padding-left: 13pt;text-indent: 0pt;line-height: 23pt;text-align: left;">
        $0</p></td>
    </tr>
  </table>
  <table style="border-collapse:collapse;margin-left:61.664pt" cellspacing="0">
    <tr style="height:29pt">
      <td
        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p class="s3" style="padding-top: 5pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">
          ATM balance inquiry (in-network or out of network)</p></td>
      <td
        style="width:115pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p class="s3"
           style="padding-top: 5pt;padding-left: 10pt;text-indent: 0pt;text-align: left;">$0</p>
      </td>
    </tr>
    <tr style="height:30pt">
      <td
        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p class="s3" style="padding-top: 5pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">
          Customer service (automated or live agent)</p></td>
      <td
        style="width:115pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p class="s3"
           style="padding-top: 5pt;padding-left: 10pt;text-indent: 0pt;text-align: left;">$0</p>
      </td>
    </tr>
    <tr style="height:30pt">
      <td
        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:2pt">
        <p class="s3" style="padding-top: 6pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">
          Inactivity</p></td>
      <td
        style="width:115pt;border-top-style:solid;border-top-width:1pt;border-bottom-style:solid;border-bottom-width:2pt">
        <p class="s3"
           style="padding-top: 6pt;padding-left: 10pt;text-indent: 0pt;text-align: left;">$0</p>
      </td>
    </tr>
    <tr style="height:30pt">
      <td
        style="width:312pt;border-top-style:solid;border-top-width:2pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p class="s5" style="padding-top: 6pt;padding-left: 6pt;text-indent: 0pt;text-align: left;">
          We charge 0 other types of fees.</p></td>
      <td
        style="width:115pt;border-top-style:solid;border-top-width:2pt;border-bottom-style:solid;border-bottom-width:1pt">
        <p style="text-indent: 0pt;text-align: left;"><br/></p></td>
    </tr>
  </table>
  <h2 style="padding-left: 68pt;text-indent: 0pt;line-height: 17pt;text-align: left;">No
    overdrafts/credit feature.</h2>
  <p class="s6" style="padding-left: 68pt;text-indent: 0pt;line-height: 15pt;text-align: left;">Your
    funds are eligible for FDIC insurance.</p>
  <p style="text-indent: 0pt;text-align: left;"><br/></p>
  <p style="padding-left: 68pt;text-indent: 0pt;text-align: left;"><a
    href="https://www.consumerfinance.gov/prepaid-rule/"
    style=" color: black; font-family:Calibri, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt;"
    target="_blank">For general information about prepaid accounts, visit </a><a
    href="https://www.consumerfinance.gov/prepaid-rule/" target="_blank">cfpb.gov/prepaid</a></p>
  <p class="s6" style="padding-left: 68pt;text-indent: 0pt;text-align: left;">Find details and
    conditions for all fees and services in the cardholder agreement.</p>
</div>
